/**
 * @param
 * @field /device/mobile/student/card/v1/company/{company}/sncode/{snCode}/info
 * @method GET
 * @name device
 * @description 根据设备编号获取学生证信息
 */
export interface IGetCardInfoBySncodeParams {
  snCode: string;
  company?: string;
}

/**
* @returns
* @description 根据设备编号获取学生证信息
*/
export type IGetCardInfoBySncodeResponse = IDeviceStatusInfo ;

/**
 * @global
 */
export type IDeviceStatusInfo = {
  status?: number;
  electricityRate?: string;
  userName?: string;
  headImageUrl?: string;
  isOnLine?: boolean;
}

/**
 * @global
 */
export const DeviceStatus = {
  online: 1,
  offline: 2,
  locked: 3,
  forbid: 4,
  unknown: -1
}